import React from "react";
import "./ReloadSessionContainer.css";
import { Button } from "@mui/material";

export default function ReloadSessionContainer({
  handleSessionReload,
  handleSessionReloadClose,
}) {
  const isFullScreen = localStorage.getItem("openInFullScreen");

  return (
    <div
      className={
        isFullScreen
          ? "showFullScreenReloadFlowContainer"
          : "realodFlowContainer"
      }
    >
      Hello User, Seems the conversation has been disconnected, Do you want to
      reload the conversation ?
      <div className="reloadSessionFooterIcons">
        <Button
          style={{
            background: "#068706",
            color: "#fff",
            marginRight: "10px",
            fontWeight: "bold",
          }}
          onClick={() => handleSessionReload()}
        >
          Yes
        </Button>
        <Button
          style={{
            background: "#dd211d",
            color: "#fff",
            fontWeight: "bold",
          }}
          onClick={() => handleSessionReloadClose()}
        >
          No
        </Button>
      </div>
    </div>
  );
}
